import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {post, get} from '../../../helpers/api_helper'
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const SettleToBank = () => {
  const navigate = useNavigate()
  const [bankDetailsAvailable, setBankDetailsAvailable] = useState(false);
  const [settlementAmount, setSettlementAmount] = useState('');
  const [message, setMessage] = useState('');
  const [openModal, setOpenModal] = useState(false);


  useEffect(() => {
    checkBankDetails();
  }, []);

  const checkBankDetails = async () => {
    try {
     
      const response = await get('/checkBankDetails') 
      if (response.status === '1') {
        toast.success(response.message)
        setBankDetailsAvailable(true);
      } else {
        if(response.status ==='0')
        setBankDetailsAvailable(false);
        setOpenModal(true);
       
      }
    } catch (error) {
      console.error('Error checking bank details:', error);
    }
  };

  const handleSettlement = async () => {
    try {
       if(parseInt(settlementAmount)<100){
        toast.error("Enter and amount greater or equal to 100 to settle.")
        return;
      }
      const response = await post('/settleBalance', {settlementAmount})

      if (response.status === '1') {
        toast.success(response.message)
        navigate('/userDash/settlementreports')
        setSettlementAmount('');
      } else {
        toast.error(response.message)
      }
    } catch (error) {
      console.error('Error settling balance:', error);
    }
  };

  const navigateToUpdateBank = () => {
    navigate('/userDash/manageBank'); 
  };

  return (
    <div>
        <ToastContainer/>
      {bankDetailsAvailable ? (
        <div className='flex justify-center  relative top-32 py-12 w-full p-8' >
        <div className='flex w-fit p-16 shadow-xl space-x-2'> 

          <TextField
            type="number"
            variant="filled"
            label="Enter settlement amount"
            size='small'
            value={settlementAmount}
            onChange={(e) => setSettlementAmount(e.target.value)}
          
          />
       
          <Button variant="contained" color="primary" onClick={handleSettlement}>
            Settle
          </Button>
          </div>
       
       
        </div>
      ) : (
        
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <DialogTitle>Update Bank Details</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModal(false)} color="primary">
            Close
          </Button>
          <Button onClick={navigateToUpdateBank} color="primary" autoFocus>
            Update
          </Button>
        </DialogActions>
      </Dialog>
      )}

      
    </div>
  );
};


export default SettleToBank;
